import { isApiRecord, type ApiValue } from './responseDecoders'

/**
 * RFC-1612: result of `POST /projects/{id}/assets/c2pa-download` (request) and
 * `GET ...?asset_path=` (status). `pending` means the video worker is signing.
 */
export interface C2paDownloadResult {
  status: 'signed' | 'unsigned' | 'pending'
  /** Project-relative path to download (signed copy, or the original). */
  assetPath: string
  /** Bounded reason when unsigned (e.g. `disabled`, `source_too_large`). */
  reason: string | null
  /** True when an already stored signed copy was returned. */
  cached: boolean
  /** The video-worker signing job, when one is involved. */
  jobId?: string | null
}

export function decodeC2paDownload(raw: ApiValue): C2paDownloadResult {
  if (!isApiRecord(raw)) throw new Error('c2pa download: expected an object')
  const { status, asset_path: assetPath, reason, cached, job_id: jobId } = raw
  if (status !== 'signed' && status !== 'unsigned' && status !== 'pending') {
    throw new Error('c2pa download: unexpected status')
  }
  if (typeof assetPath !== 'string' || assetPath === '') {
    throw new Error('c2pa download: missing asset_path')
  }
  return {
    status,
    assetPath,
    reason: typeof reason === 'string' ? reason : null,
    cached: cached === true,
    jobId: typeof jobId === 'string' ? jobId : null,
  }
}
